import React, { useState } from "react";
import { QrCode, Loader2 } from "lucide-react";
import { getEstiloPlaca, formatarPlaca } from "../../utils/formatters";

const PlacaDisplay = ({ placa, clicavel = false }) => {
  const [showCopiedMessage, setShowCopiedMessage] = useState(false);
  const isLoading = !placa;

  const handleCopyPlaca = () => {
    if (!clicavel || !placa) return;

    const placaLimpa = placa.replace(/[^a-zA-Z0-9-]/g, "").toUpperCase();
    navigator.clipboard
      .writeText(placaLimpa)
      .then(() => {
        setShowCopiedMessage(true);
        setTimeout(() => {
          setShowCopiedMessage(false);
        }, 2000);
      })
      .catch((err) => {
        console.error("Falha ao copiar a placa: ", err);
      });
  };
  const estilo = getEstiloPlaca(placa);
  const containerClasses =
    estilo === "antigo"
      ? "bg-gray-200 border-gray-800"
      : "bg-white border-gray-400";

  const fontClasses = isLoading
    ? "text-3xl sm:text-4xl tracking-normal text-gray-400"
    : estilo === "antigo"
    ? "text-black font-placa-antiga"
    : "text-black font-placa-mercosul";

  return (
    <div className="w-full max-w-md mt-6 relative">
      <div
        className={`rounded-lg border-4 shadow-xl relative overflow-hidden transform -translate-y-6 ${containerClasses}`}
      >
        {estilo === "mercosul" && (
          <div className="top-0 left-0 right-0 h-8 sm:h-9 bg-blue-700 flex items-center justify-center relative">
            <span className="absolute left-2 text-[8px] sm:text-[10px] font-semibold text-white">
              MERCOSUL
            </span>
            <span className="text-white font-extrabold text-xs sm:text-sm tracking-widest">
              BRASIL
            </span>
            <img
              src="/bandeira-brasil.svg"
              alt="Bandeira do Brasil"
              className="h-4 sm:h-5 absolute right-2 top-1/2 -translate-y-1/2"
            />
          </div>
        )}
        {estilo === "antigo" && (
          <div className="w-2/3 mx-auto mt-2 sm:mt-4 h-6 sm:h-7 bg-gray-200 border-2 border-gray-500"></div>
        )}

        <div
          className={`px-2 sm:px-4 py-4 sm:py-6 relative flex items-center justify-center ${
            estilo === "mercosul" ? "pt-8 sm:pt-10" : ""
          }`}
        >
          {estilo === "mercosul" && (
            <>
              <QrCode className="absolute top-1 left-1 w-5 h-5 sm:w-7 sm:h-7 text-gray-700" />
              <div className="absolute bottom-1 left-1 text-black">
                <span className="text-sm sm:text-base font-bold text-gray-700">
                  BR
                </span>
              </div>
            </>
          )}

          <div className="relative group">
            <h2
              onClick={isLoading ? undefined : handleCopyPlaca}
              className={`text-4xl sm:text-5xl lg:text-6xl font-bold tracking-widest text-center [text-shadow:1px_1px_2px_rgba(0,0,0,0.3)] ${fontClasses} ${
                clicavel && !isLoading ? "cursor-pointer" : ""
              }`}
              role={clicavel && !isLoading ? "button" : undefined}
              tabIndex={clicavel && !isLoading ? 0 : -1}
              onKeyDown={(e) =>
                clicavel && !isLoading && e.key === "Enter" && handleCopyPlaca()
              }
            >
              {isLoading ? (
                <Loader2 className="h-12 w-12 sm:h-16 sm:h-16 mx-auto animate-spin text-gray-400" />
              ) : (
                formatarPlaca(placa)
              )}
            </h2>
            {clicavel && !isLoading && (
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-max px-3 py-1 bg-gray-800 text-white text-xs rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                Clique para copiar
              </div>
            )}
          </div>
        </div>
      </div>

      {showCopiedMessage && (
        <div className="absolute bottom-[-40px] left-1/2 -translate-x-1/2 w-max px-4 py-2 bg-green-600 text-white text-sm font-semibold rounded-md shadow-lg transition-all duration-300 transform -translate-y-6">
          Placa copiada com sucesso!
        </div>
      )}
    </div>
  );
};

export default PlacaDisplay;
